/**
 * Stopwatch.
 *
 * @copyright Realeyes OU. All rights reserved.
 */
import getCurrentTime from './getCurrentTime';

export default class Stopwatch {
    /**
     * Creates TimeSyncService instance.
     */
    constructor() {
        this.startTime = null;
    }

    /**
     * Returns current instance of syncService.
     * @return{TimeSyncService}
     */
    start() {
        this.startTime = getCurrentTime();
    }

    /**
     * Returns elapsed amount of milliseconds or null if timer wasn't started
     * @return{int}
     */
    elapsed() {
        if (!this.startTime) {
            return null;
        }
        return getCurrentTime() - this.startTime;
    }
}
